import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter(customer_id, agro_exporter_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_containers/${customer_id}/agro_exporter/${agro_exporter_id}`
    );
  },
  fetchAgroExporterProcess(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_containers/${customer_id}/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(customer_id, container_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_reports/${customer_id}/container/${container_id}`
    );
  },
  fetchQualityTemplateMainReps(customer_id, container_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_reports/${customer_id}/list_quality_template_main_reps/${container_id}`
    );
  },
  fetchCustomerReports(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_reports/${customer_id}/list_customer_reports/${agro_exporter_process_id}`
    );
  }
};
